var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.546 1.0375C11.8392 0.103711 13.1608 0.103713 13.454 1.03751L15.5355 7.6644C15.6664 8.08118 16.0527 8.36475 16.4895 8.36475H23.2954C24.2559 8.36475 24.664 9.58705 23.8962 10.1641L18.3325 14.3458C17.9938 14.6004 17.8523 15.0407 17.9792 15.4449L20.0905 22.1668C20.3818 23.0941 19.3127 23.8499 18.5357 23.2659L13.1008 19.1811C12.7449 18.9136 12.2551 18.9136 11.8992 19.1811L6.46433 23.2659C5.68734 23.8499 4.6182 23.0941 4.90946 22.1668L7.02076 15.4449C7.14771 15.0407 7.00619 14.6004 6.66753 14.3458L1.10377 10.1641C0.335962 9.58705 0.744091 8.36475 1.70459 8.36475H8.51047C8.94732 8.36475 9.33361 8.08118 9.46452 7.6644L11.546 1.0375Z",
    fill: "#FACA2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.fae7a24184cc46113d4ac30445386332.svg";
export { ForwardRef as ReactComponent };